// Hide registration wall when room filters are applied

;(function () {
  if (!document.body.classList.contains("show-registration-wall")) return

  let toggle = function (visible) {
    let container = document.querySelector(".registration-wall--container")
    if (!container) return

    let currentlyVisible = !container.classList.contains("hidden")
    if (currentlyVisible === visible) return

    document.body.classList.toggle("show-registration-wall", visible)
    container.classList.toggle("hidden", !visible)

    Activity.track(
      "registration-wall",
      visible ? "filter-show" : "filter-hide",
      container.dataset.source,
    )
  }

  $(document).on({
    "room-filters:applied": function () {
      toggle(false)
    },
    "room-filters:removed": function () {
      toggle(true)
    },
  })
})()
